import React from "react";
import "./Synonyms.css";

export default function Synonyms(props) {
    //if there are synonyms in the definition
    if (props.synonyms) {
        return (
            <ul className="Synonyms">
                {/* for each synonym */}
                {props.synonyms.map(function (synonym, index) {
                    /* display that synonym */
                    return <li key={index}>{synonym}</li>;
                })}
            </ul>
        );
    }
    else {
        return null;
    }
}
